import { PRODUCT_VALUE_SECTION_2 } from '@app/routes/urls';
import { LocationChangeAction } from 'connected-react-router';
import { put } from 'redux-saga/effects';
import {
  fetchProductGroupLabeling,
  setLoadingGroupsLabelingTableAction,
} from '../actions';

export function* productLabelingWorkerSaga(action: LocationChangeAction) {
  const { search, pathname } = action.payload.location;

  if (PRODUCT_VALUE_SECTION_2.match(pathname, true).isMatched && search) {
    yield put(setLoadingGroupsLabelingTableAction({ payload: true }));
    yield put(fetchProductGroupLabeling({}));
  }
}
